import React from 'react';
import { reportReactRenderError } from '../utils/slackErrorReporter';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportReactRenderError(error, errorInfo?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, textAlign: 'center', fontSize: 18 }}>
          Ocurrió un error inesperado. Por favor, recargá la página.
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
